import { matchPath } from 'react-router-dom';

import { ROUTES } from 'configs/routes';
import { Devices } from 'utils/devices';

export type SplitPageConfig = {
  path: string;
  /** На планшете и телефоне хедер и контент без зазора. На десктопе не склеиваются. */
  mergeHeaderAndContent?: boolean;
};

export const SPLIT_PAGE_CONFIGS: SplitPageConfig[] = [
  { path: ROUTES.lk.profile.path },
  { path: ROUTES.lk.accessManagement.path },
  { path: ROUTES.lk.lots.path },
  { path: ROUTES.lk.favorites.path },
  { path: ROUTES.lk.promotions.path, mergeHeaderAndContent: true },
  { path: ROUTES.lk.publications.path, mergeHeaderAndContent: true },
  { path: ROUTES.lk.projects.detail.publication.path, mergeHeaderAndContent: true },
  { path: ROUTES.lk.projects.detail.promotion.path, mergeHeaderAndContent: true },
];

export const resolveSplitPageConfig = (pathname: string, device: Devices) => {
  const config = SPLIT_PAGE_CONFIGS.find(({ path }) => matchPath({ path, end: false }, pathname));

  return {
    enabled: Boolean(config),
    mergeHeaderAndContent: config?.mergeHeaderAndContent === true && device !== 'desktop',
  };
};
